import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M2.086 11.449c4.872 1.499 15.66 3.583 19.847-.07M3.949 11.19 5.36 4.277c.237-1.192 1.381-1.869 2.474-1.497l3.308 1.193c.523.2 1.103.162 1.618-.133l2.623-1.454c1.454-.776 3.282.07 3.784 1.788.5 1.692.648 4.296-1.579 4.025-2.519-.278-2.13-3.205-.168-3.282 2.976-.145 3.808 3.982 3.808 3.982"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M11.11 18.909a3.313 3.313 0 1 1-6.625 0 3.313 3.313 0 0 1 6.626 0M21.05 18.909a3.313 3.313 0 1 1-6.626 0 3.313 3.313 0 0 1 6.626 0M11.11 18.909h3.314"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const AnonymIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
